module.exports = __webpack_public_path__ + "img/hiw_icon_Result_Errors_Census.0124c73a.png";